import type { AffiliateApiResponse } from '@modules/affiliate-api/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_API_API_URL,
  AFFILIATE_API_PERMISSIONS,
  AFFILIATE_API_QUERY_KEY,
} from '@modules/affiliate-api/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

export default function useAffiliateApiQuery(): IContextQueryResult<AffiliateApiResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [AFFILIATE_API_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<AffiliateApiResponse>(
      AFFILIATE_API_API_URL,
      {
        signal,
        permission: AFFILIATE_API_PERMISSIONS.SHOW,
      },
    ),
  });
}
